import React, {Component} from 'react'
import {withStyles} from '@material-ui/core/styles'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import {FuseAnimate, FuseUtils} from '@fuse'
import {bindActionCreators} from 'redux'
import ReactTable from "react-table"
import moment from "moment"
import {Button, MenuItem, Select} from "@material-ui/core"
import {constDataDialogs} from "../../../../constants"
import ReduxGlobal from "../../../../store/actionreducers/globalView"
import {UecareStatus} from "../../../../components"
import Icon from "@material-ui/core/Icon"
import Tooltip from "@material-ui/core/Tooltip"
import ReduxUser from "../../../../store/actionreducers/user"

class FeedbackList extends Component {

    getFilteredArray = (entities, searchText) => {
        const arr = Object.keys(entities).map((id) => entities[id])
        if (searchText.length === 0) {
            return arr
        }
        return FuseUtils.filterArrayByString(arr, searchText)
    };

    render() {
        const { classes, searchText, feedbackList, openDataDialog, setFeedback, getUser} = this.props

        const data = this.getFilteredArray(feedbackList.map(s => ({
                ...s,
                userId: s.user.id,
                time: moment(s.time).format('YYYY/MM/DD HH:mm'),
                identity: (s.user.user_type === 'vip'? s.user.vip.identity : s.user.user_type),
                status: (s.user.user_type === 'vip' ? s.user.vip.status : s.user.medical.status),
                title: (s.title ? s.title : '無主旨')
            })), searchText)

        return (
            <FuseAnimate animation="transition.slideUpIn" delay={300}>
                <ReactTable
                    filterable
                    previousText='Previous'
                    nextText='Next'
                    loadingText='Loading...'
                    noDataText="目前沒有任何回饋紀錄"
                    pageText='頁'
                    ofText='/共'
                    rowsText='筆'
                    data={data.sort((preFeedback, currFeedback) => currFeedback.id - preFeedback.id)
                    }
                    columns={[
                        {
                            Header: '編號',
                            accessor: 'id',
                            filterable: true,
                            width: 80,
                            className: 'justify-center',
                        },
                        {
                            Header: '填寫人',
                            accessor: 'user.name',
                            filterable: true,
                            width: 80,
                            className: 'justify-center',

                        },
                        {
                            Header: '電子郵件',
                            accessor: 'user.email',
                            filterable: true,
                            width: 250,
                            className: 'justify-center',
                        },
                        {
                            Header: '身分',
                            accessor: 'identity',
                            filterable: true,
                            Cell: row => ({
                                national: <div>國內</div>  ,
                                overseas: <div>海外</div>,
                                foreigners: <div>外籍</div>,
                                medical: <div>醫師</div>,
                            }[row.value]),
                            Filter: ({ filter, onChange }) => (
                                <Select
                                    onChange={({ target: { value } }) => onChange(value)}
                                    style={{ width: '100%' }}
                                    value={filter ? filter.value : ''}
                                >
                                    <MenuItem value="all">全部</MenuItem>
                                    <MenuItem value="national">國內會員</MenuItem>
                                    <MenuItem value="overseas">海外會員</MenuItem>
                                    <MenuItem value="foreigners">外籍會員</MenuItem>
                                    <MenuItem value="medical">醫師</MenuItem>
                                </Select>
                            ),
                            filterMethod: ({ value }, { identity }) => value === 'all' || value === identity ,
                            width: 125,
                            className: 'justify-center',
                        },
                        {
                            Header: '狀態',
                            accessor: 'status',
                            Cell: row => (<UecareStatus name={row.value.name} label={row.value.label}/>),
                            filterable: true,
                            sortMethod: ({ id: a }, { id: b }) => a > b ? 1 : a < b ? -1 : 0,
                            Filter: ({filter, onChange}) => (
                                <Select
                                    value={filter ? filter.value : ''}
                                    style={{width: "100%"}}
                                    onChange={event => {
                                        onChange(event.target.value);
                                    }}
                                    name="selectStatus"
                                >
                                    <MenuItem value="all">全部</MenuItem>
                                    <MenuItem value="activated">已開通</MenuItem>
                                    <MenuItem value="to_call">等待通知</MenuItem>
                                    <MenuItem value="to_contract">等待簽約</MenuItem>
                                    <MenuItem value="to_pay">等待付款</MenuItem>
                                    <MenuItem value="to_validate">等待驗證信箱</MenuItem>
                                </Select>
                            ),
                            filterMethod: (filter, row) => {
                                if (filter.value === 'all') return true
                                const status = row.status.label;
                                return status === filter.value;
                            },
                            width: 120,
                            className: "justify-center",
                        },
                        {
                            Header: () => (
                                <div>
                                    <Tooltip title="點按主旨可查看詳細內容" classes={classes.tooltip}>
                                        <div>回饋主旨<Icon className={classes.info}>info</Icon></div>
                                    </Tooltip>
                                </div>
                            ),
                            accessor: 'title',
                            Cell: row => {
                                const {
                                    userId,
                                    title,
                                } = row.original

                                return <Button
                                    onClick={async (ev) => {
                                        try {
                                            ev.stopPropagation()
                                            getUser(userId)
                                            setFeedback(row.original)
                                            openDataDialog({
                                                type: constDataDialogs.type.view,
                                                name: constDataDialogs.name.feedbackDialog,
                                            })
                                        } catch (e) {
                                            console.warn('you got an error = ', e)
                                        }
                                    }}
                                >
                                    {title}
                                </Button>
                            },
                            filterable: true,
                            width: 250,
                            className: "justify-center",
                        },
                        {
                            Header: '回饋時間',
                            accessor: 'time',
                            filterable: true,
                            width: 150,
                            className: 'justify-center',
                        },

                    ]}
                    defaultPageSize={5}
                />
            </FuseAnimate>
        );
    }
}

const styles = theme => ({
    avatar: {
        backgroundColor: theme.palette.primary[500]
    },
    labels: {},
    tooltip: {
        maxWidth: 100,
        backgroundColor: '#0abb34',
    },
    info: {
        color: '#00aaff',
    }
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getUser: ReduxUser.ActionCreator.getUser,
        openDataDialog: ReduxGlobal.ActionCreator.openDataDialog,
    }, dispatch)
}

function mapStateToProps({global: {searchText}}) {
    return {searchText}
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(FeedbackList)))



// WEBPACK FOOTER //
// ./src/main/content/callHelper/feedback/FeedbackList.js